import { render, staticRenderFns } from "./DialogUpdateNews.vue?vue&type=template&id=38a2e348&scoped=true&"
import script from "./DialogUpdateNews.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateNews.vue?vue&type=script&lang=js&"
import style0 from "./DialogUpdateNews.vue?vue&type=style&index=0&id=38a2e348&lang=scss&scoped=true&"
import style1 from "./DialogUpdateNews.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a2e348",
  null
  
)

export default component.exports